import { AppBar as MuiAppBar, Toolbar } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    bottomBar: {
        bottom: 0,
        background: 'none',
        minHeight: 'auto',
        padding: 0,
        top: 'auto',
        '& .MuiToolbar-root': {
            paddingLeft: 0,
            paddingRight: 0
        }
    },
    toolBar: {
        background: 'none',
        minHeight: 'auto',
        padding: 0
    }
}));

const BottomBar = (props) => {
    const { children, elevation = 1 } = props;
    const { classes } = useStyles();

    return (
        <MuiAppBar className={classes.bottomBar} position="fixed" elevation={elevation}>
            <Toolbar className={classes.toolBar}>{children}</Toolbar>
        </MuiAppBar>
    );
};

export default BottomBar;
